/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalUserStatus } from './ExternalUserStatus';
import {
    ExternalUserStatusFromJSON,
    ExternalUserStatusFromJSONTyped,
    ExternalUserStatusToJSON,
    ExternalUserStatusToJSONTyped,
} from './ExternalUserStatus';

/**
 * 
 * @export
 * @interface ExternalUserStatusUpdateResponse
 */
export interface ExternalUserStatusUpdateResponse {
    /**
     * 
     * @type {ExternalUserStatus}
     * @memberof ExternalUserStatusUpdateResponse
     */
    status?: ExternalUserStatus;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserStatusUpdateResponse
     */
    userId?: string | null;
}



/**
 * Check if a given object implements the ExternalUserStatusUpdateResponse interface.
 */
export function instanceOfExternalUserStatusUpdateResponse(value: object): value is ExternalUserStatusUpdateResponse {
    return true;
}

export function ExternalUserStatusUpdateResponseFromJSON(json: any): ExternalUserStatusUpdateResponse {
    return ExternalUserStatusUpdateResponseFromJSONTyped(json, false);
}

export function ExternalUserStatusUpdateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalUserStatusUpdateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : ExternalUserStatusFromJSON(json['status']),
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
    };
}

export function ExternalUserStatusUpdateResponseToJSON(json: any): ExternalUserStatusUpdateResponse {
    return ExternalUserStatusUpdateResponseToJSONTyped(json, false);
}

export function ExternalUserStatusUpdateResponseToJSONTyped(value?: ExternalUserStatusUpdateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': ExternalUserStatusToJSON(value['status']),
        'userId': value['userId'],
    };
}

